/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * the list of transport stop near the institute
 * @export
 * @interface TransportStop
 */
export interface TransportStop {
    /**
     * the unique identifier of the doctor
     * @type {string}
     * @memberof TransportStop
     */
    doctorUuid?: string;
    /**
     * the unique identifier of the stop
     * @type {string}
     * @memberof TransportStop
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportStop
     */
    stop: string;
}

/**
 * Check if a given object implements the TransportStop interface.
 */
export function instanceOfTransportStop(value: object): value is TransportStop {
    if (!('stop' in value) || value['stop'] === undefined) return false;
    return true;
}

export function TransportStopFromJSON(json: any): TransportStop {
    return TransportStopFromJSONTyped(json, false);
}

export function TransportStopFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportStop {
    if (json == null) {
        return json;
    }
    return {
        
        'doctorUuid': json['doctorUuid'] == null ? undefined : json['doctorUuid'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'stop': json['stop'],
    };
}

export function TransportStopToJSON(json: any): TransportStop {
    return TransportStopToJSONTyped(json, false);
}

export function TransportStopToJSONTyped(value?: TransportStop | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'doctorUuid': value['doctorUuid'],
        'uuid': value['uuid'],
        'stop': value['stop'],
    };
}

